import { ref, computed, inject } from "vue";
import { DpaIdCollabGraphqlUseFolderListItems } from "@dpa-connect/dpa-id-collab";
import store from "@/store";
import { reduceToMinimum as formatItem } from "@/store/modules/collaboration";
import useUiStore from "@/composition/useUiStore";
import useCollaborationStore from "@/composition/useCollaborationStore";

export default newsItem => {
  const eventBus = inject<any>("eventBus");

  const { showCollabDialog, setShowCollabDialog } = useUiStore();

  const {
    dialogEventId,
    setDialogEventId,
    setSelectedFolder,
    clearSelection
  } = useCollaborationStore();

  const sidebarFolder = computed(
    () =>
      // @ts-ignore
      store.state.collaboration.isSidebarVisible &&
      // @ts-ignore
      store.state.collaboration.selectedFolder
  );

  const {
    data: folderListItems,
    variables
  } = DpaIdCollabGraphqlUseFolderListItems(
    ref({
      folderId: "",
      folderListId: ""
    }),
    false,
    false
  );

  const setFolderItemsQueryVariables = payload => {
    if (payload.id && payload.content.id) {
      variables.value = {
        folderId: payload.id,
        folderListId: payload.content.id
      };
    }
  };

  const formattedItem = computed(() => {
    // @ts-ignore
    const { encodedImages } = store.state.newsItems;
    const event = { ...newsItem.value };

    // @ts-ignore
    if (
      encodedImages[newsItem.value.guid] &&
      encodedImages[newsItem.value.guid].preview
    ) {
      event.thumbnail = encodedImages[newsItem.value.guid].preview;
    }

    return formatItem(event);
  });

  const addToFolder = () => {
    setShowCollabDialog(true);
    setDialogEventId(newsItem.value.guid);
  };

  const existingFolderListItem = computed(() =>
    folderListItems.value.find(
      ({ itemValueUnit }) => itemValueUnit.id === newsItem.value.id
    )
  );

  const collabDialogMode = ref("select");

  const handleCollabDialogSuccess = currentFolder => {
    setSelectedFolder(currentFolder);
    clearSelection();
    eventBus.$emit("sidebarRefresh");

    const successText = `Zur${
      collabDialogMode.value === "create" ? " neuen " : " "
    }Mappe hinzugefügt`;

    eventBus.$emit("appMessage", {
      model: true,
      text: successText
    });
  };

  return {
    addToFolder,
    collabDialogMode,
    dialogEventId,
    existingFolderListItem,
    formattedItem,
    handleCollabDialogSuccess,
    setFolderItemsQueryVariables,
    setShowCollabDialog,
    showCollabDialog,
    sidebarFolder
  };
};
